import { ForestProductPriceUpdatePrices as ForestProductPriceUpdatePricesComponent } from '../../../../components/ForestProduct/ForestProductPriceUpdates/ForestProductPriceUpdatePrices';

export function ForestProductPriceUpdatePrices() {
  return <ForestProductPriceUpdatePricesComponent />;
}
